import { JSEncrypt } from 'jsencrypt'
const crypt = new JSEncrypt()

let publicKey = undefined
if (location.hostname.includes('oic.oichatlife.com')){
  publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgOuKkCIVgFY61YQALD9xUVkKhzWt9mK8uBGTTUqdXlNsioh0ivdyrsmMKXAVc2tgyyWqbzvqn5M61EfSM0sD7WA18KxJb6GyM0DwpmeikULDAf4KbltPlwWDjMK7d0qFMKSPWhPWJt+Zy/vtoeT1VCtWIx4bbA1/X49426fvqh3RowbttTSLre/4RR8sbCpf8YeomhudEnDLDL0EPGN8wqQrfrcolRZdMVS0vnEEySVOoCZjZnNDwHZesjMXMCWG7if9zlv+V4/evqie7j3ux6BUjvQiW79scpXwTg6J5pIzeUhPbfJm4ICK1Nmp3S1vmR8mW06NP2TB5RvOKBjD6QIDAQAB'
} else {
  publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjcZPPAS/wGSfoi6NLzKdd6slG5FWy9cREeG35TayMcScY/Ez/tOuODiNpcmxtXzywkc7Z1FbKwIbeBgBm/5XvkDkhxI9TR7ZF69IlpHvs9r+HcokmhZiFF/TDQSwOrMo20j3Y4FEfoNivteDotCLK+S4BQNcHxroE+agy0GAbkPXjWkBRixxXEP7XKbYq1hfnoLQH8lFYOsIo0617wycLgAUR9caJnlFIRsLM9BhFFyixcfQQZ6NmNfPkoT2ZsDwSa4mwKqdVwau+c8izN/J53MFTMJ2bpkzFM+1MYdbpzqcUFj9g4AyTJxgzpCgLV5ylttihxSWtitJ57nI/ftjHwIDAQAB'
}

crypt.setPublicKey(publicKey)

crypt.encryptLong = str => {
  if (!str) return ''

  const maxLength = 240
  if (str.length <= maxLength) {
    return crypt.encrypt(str)
  }

  const encryptedParts = []
  for (let i = 0; i < str.length; i += maxLength) {
    const part = str.substring(i, i + maxLength)
    const encryptedPart = crypt.encrypt(part)
    if (encryptedPart === false || encryptedPart === null) {
      throw new Error('Encryption failed for part: ' + part)
    }
    encryptedParts.push(encryptedPart)
  }

  return encryptedParts.join(',')
}
export default crypt
